import React, {Component} from 'react';
import {Link} from 'react-router';
import Translate from '../layout/Translate';

export default class Discount extends Component {


    componentWillMount() {


    }


    toggleDiscountInfo() {
        this.props.toggle();
    }

    render() {
        
        return (

            <div className={"popup " + (this.props.open?'popup_active':'')}>
                <div className="popup__window popup__window_reviews">
                    <div className="popup__close" onClick={this.toggleDiscountInfo.bind(this)}></div>
                    <div className="discount-info__title">
                        <Translate slug="reviews__how-work" />
                    </div>
                    
                    <div>
                        <Translate slug="reviews__how-work__text1" html={true} />
                        <Translate slug="reviews__how-work__text2" html={true}  />
                        <Translate slug="reviews__how-work__text3" html={true}  />
                    </div>

                </div>

                
            </div>


        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/popups/ReviewsConditions.js